var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"animate-css",rawName:"v-animate-css",value:('fadeInUp'),expression:"'fadeInUp'"}],staticClass:"login-logo"},[_c('a',{attrs:{"href":""}},[_c('img',{staticStyle:{"opacity":".9","width":"300px"},attrs:{"src":_vm.logo,"alt":"Logo"}}),_c('span',{staticClass:"brand-text font-weight-light"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }